module.exports = __webpack_public_path__ + "img/checklist.45cc1406.jpg";